<template>
  <div class="gender">
    <b-button-group class="gender-options" data-test-id="GenderButtons">
      <b-button class="gender-option" data-test-id="MaleButton" :pressed="gender === 'M'" @click="setGender('M')"
        >M</b-button
      >
      <b-button class="gender-option" data-test-id="FemaleButton" :pressed="gender === 'F'" @click="setGender('F')"
        >F</b-button
      >
    </b-button-group>
  </div>
</template>

<script>
export default {
  name: "Gender",

  props: {
    selectedGender: {
      default: "",
      type: String,
    },
  },

  data() {
    return {
      gender: null,
    };
  },

  mounted() {
    const gender = this.selectedGender || null;

    if (gender) {
      this.gender = gender.toUpperCase();
    }
  },

  methods: {
    setGender(gender) {
      if (this.gender === gender) {
        this.gender = null;
        this.$emit("gender-updated", this.gender);

        return;
      }

      this.gender = gender;
      this.$emit("gender-updated", this.gender);
    },
  },
};
</script>

<style scoped>
.gender {
  flex: 0 1 auto;
}

.gender-option {
  background-color: transparent;
}

.gender-option.active {
  background-color: white !important;
  color: black !important;
}
</style>
